(function () {
	angular
		.module('trackeye')
		.factory('NotificationService', NotificationService);

	NotificationService.$inject = [];

	function NotificationService() {
		var exports = {},
			events = {};

		exports.on = function (eventName, callback) {
			if (!events[eventName])
				events[eventName] = [];

			events[eventName].push(callback);
		};

		exports.notice = function (type, message) {
			if (!exports[type])
				return;

			exports[type](message);
		};

		exports.byLogHandle = function (handle) {
			if (handle.isSilent())
				return;

			if (!handle.getNoticeMessage()) {
				console.warn('Logger::' + handle.name + ' No notice message');
				return;
			}

			emit("notice", {
				message: handle.getNoticeMessage(),
				translate_values: handle.getTranslateValues(),
				type: handle.getNoticeType()
			});
		};

		exports.success = function (message, translate_values) {
			emit("notice", {
				message: message,
				translate_values: translate_values,
				type: "success"
			});
		};

		exports.primary = function (message, translate_values) {
			emit("notice", {
				message: message,
				translate_values: translate_values,
				type: "primary"
			});
		};

		exports.info = function (message, translate_values) {
			emit("notice", {
				message: message,
				translate_values: translate_values,
				type: "info"
			});
		};

		exports.warning = function (message, translate_values) {
			emit("notice", {
				message: message,
				translate_values: translate_values,
				type: "warning"
			});
		};

		exports.danger = function (message, translate_values) {
			emit("notice", {
				message: message,
				translate_values: translate_values,
				type: "danger"
			});
		};

		function emit(eventName, data) {
			if (!events[eventName])
				return;

			for (var i = 0; i < events[eventName].length; i++) {
				events[eventName][i](data);
			}
		}

		return exports;
	}
})();